import React from "react";

const SectionTitle = ({ children }) => {
  return (
    <div
      class="font-serif"
      style={{ fontVariant: "small-caps", textTransform: "capitalize" }}
    >
      {children}
    </div>
  );
};

export default SectionTitle;
